import type { ReactNode } from "react";
import { Text } from "~/components/text";

/** One label/value line inside the chart tooltip. */
export const AmazonSalesTooltipRow = ({
  label,
  value,
  indicator,
}: {
  label: string;
  value: string;
  /** Optional colour swatch shown before the label for charted series. */
  indicator?: ReactNode;
}) => (
  <div className="flex items-center justify-between gap-4">
    <Text as="span" variant="tooltip" className="flex items-center gap-1.5">
      {indicator}
      {label}
    </Text>
    <Text as="span" variant="tooltip" numeric="mono">
      {value}
    </Text>
  </div>
);
